import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_58aca9c2-2cb6-4ff9-a615-17272856b112/artifacts/wb3ejkz9_Logo%20-%20Transparent.png";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-zinc-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img src={LOGO_URL} alt="Tech Distribution" className="h-8 w-auto" />
            <p className="text-zinc-400 text-sm">
              Australia's trusted distributor for industrial networking, solar controllers, power supplies, and outdoor enclosures.
            </p>
            <div className="flex items-center space-x-2 text-zinc-400 text-sm">
              <MapPin className="h-4 w-4 text-[#78BE20]" />
              <span>Sydney, Australia</span>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-4">Products</h4>
            <ul className="space-y-2">
              <li><Link to="/category/tachyon-networks" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">Tachyon Networks</Link></li>
              <li><Link to="/category/solar-controllers" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">Solar Controllers</Link></li>
              <li><Link to="/category/dc-converters" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">DC Converters</Link></li>
              <li><Link to="/category/dc-power-supplies" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">Power Supplies</Link></li>
              <li><Link to="/category/outdoor-cabinets" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">Outdoor Cabinets</Link></li>
              <li><Link to="/category/ac-cabinets" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">AC Cabinets</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">Contact</Link></li>
              <li><Link to="/projects" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">Projects</Link></li>
              <li><Link to="/trade-application" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">Trade Account</Link></li>
              <li><Link to="/account" className="text-zinc-400 hover:text-[#78BE20] text-sm transition-colors">My Account</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-[#78BE20]" />
                <span className="text-zinc-400 text-sm">1300 TECH DIST</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-[#78BE20]" />
                <span className="text-zinc-400 text-sm">sales@techdistribution.com.au</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-zinc-500 text-sm">
            © {new Date().getFullYear()} Tech Distribution. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <span className="text-zinc-500 text-sm">ABN: 12 345 678 901</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
